/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Clear_TimecodesInputs */

const en_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Timecodes`)
};

const fr_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les timecodes`)
};

const de_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes löschen`)
};

const it_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella i timecode`)
};

const ru_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить временные метки`)
};

const es_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar códigos de tiempo`)
};

const zh_cn2_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除时间码`)
};

const ja_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードをクリアする`)
};

const hi_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय कोड साफ़ करें`)
};

const pt_pt2_shortcut_keys_name_clear_timecodes = /** @type {(inputs: Shortcut_Keys_Name_Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar códigos de tempo`)
};

/**
* | output |
* | --- |
* | "Clear Timecodes" |
*
* @param {Shortcut_Keys_Name_Clear_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_clear_timecodes = /** @type {((inputs?: Shortcut_Keys_Name_Clear_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Clear_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "de") return de_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "it") return it_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "es") return es_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_clear_timecodes(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_clear_timecodes(inputs)
	return en_shortcut_keys_name_clear_timecodes(inputs)
});